import React from 'react';

import { Modal, Input, Form } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

import withTranslations from 'app/components/HOGs/withTranslations';

// eslint-disable-next-line import/no-cycle
import { academyConst } from '../academy';

const ListModal = ({ state, changeState, save, tr }) => {
  const { modalShow, savingLoading, action, type } = state;

  const intl = useIntl();

  const [form] = Form.useForm();

  const okText = savingLoading ? <LoadingOutlined /> : tr.Save;

  const titleText = intl.formatMessage({
    id: `Create new ${type}`,
    defaultMessage: `Create new ${type}`,
  });

  const inputText = intl.formatMessage({
    id: `Enter name of the ${type}`,
    defaultMessage: `Enter name of ${type}`,
  });

  const editTitleText = intl.formatMessage({
    id: `Change ${type} name`,
    defaultMessage: `Change ${type} name`,
  });

  const handleSubmit = (values) => {
    const { name, video_id = null } = values;
    let videoId;
    if (video_id) {
      const url = video_id.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      videoId = url[2] !== undefined ? url[2].split(/[^0-9a-z_-]/i)[0] : url[0];
    }
    save(name, videoId, form);
  };

  const handeleClose = () => {
    changeState({ modalShow: false });
    form.resetFields();
  };

  return (
    <Modal
      title={action === academyConst.EDIT ? editTitleText : titleText}
      visible={modalShow}
      centered
      onCancel={handeleClose}
      onOk={() => form.submit(handleSubmit)}
      okText={okText}
      cancelText={tr.Cancel}
      className="createListAcademy"
      closable
    >
      <Form onFinish={handleSubmit} form={form}>
        <Form.Item
          hasFeedback
          name="name"
          rules={[
            {
              required: true,
              message: inputText,
            },
          ]}
        >
          <Input placeholder={inputText} />
        </Form.Item>

        {type === academyConst.LESSON && !action ? (
          <Form.Item
            hasFeedback
            name="video_id"
            rules={[
              {
                required: true,
                message: tr['Paste the code or link'],
              },
            ]}
          >
            <Input placeholder={tr['Paste the code or link']} />
          </Form.Item>
        ) : null}
      </Form>
    </Modal>
  );
};

export default withTranslations(ListModal);
